import { BookingCountdown } from '@shared/BookingTimerContainer/BookingCountdown';
import { useBookingTimer } from './hooks/useBookingTimer';

interface BookingTimerContainerProps {
  // дата окончания времени на оплату
  validDateTime: string | null;
  // флаг процесса отправки формы
  isSubmitting: boolean;
  // коллбек при истечении времени
  onTimeout: () => void;
}

/**
 * Контейнер для таймера оплаты
 *
 * Использует useBookingTimer для определения параметров таймера
 * и отображает BookingCountdown с соответствующими настройками
 */
export const BookingTimerContainer = ({
  validDateTime,
  isSubmitting,
  onTimeout,
}: BookingTimerContainerProps) => {
  const { shouldShowTimer, duration, label } = useBookingTimer({
    validDateTime,
    isSubmitting,
  });

  if (!shouldShowTimer) {
    return null;
  }

  return (
    <div className=" text-center">
      <BookingCountdown duration={duration} onComplete={onTimeout} label={label} />
    </div>
  );
};
